export class QuarterlyTaxReceiptConst {
    public static headerTable = [
        { field: 'taxYear', title: 'Ejercicio', cell: (row) => `${row.taxYear}`, class: (row) => `` },
        { field: 'period', title: 'Periodo', cell: (row) => `${row.period}`, class: (row) => `` },
        { field: 'taxFormModel', title: 'Modelo', cell: (row) => `${row.taxFormModel}`, class: (row) => `` },
        { field: 'receiptNumber', title: 'Número de justificante', cell: (row) => `${row.receiptNumber}`, class: (row) => `` },
        { field: 'amount', title: 'Importe', cell: (row) => `${row.amount}`, class: (row) => `` },
    ];
}